module.exports = __webpack_public_path__ + "static/img/8.7803e05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/8.png
// module id = Vf2o
// module chunks = 0